import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

export default function Footer() {
  return (
    <footer>
      <div className="footer-main">
        <div className="footer-brand">
          <Link to="/" className="footer-logo">
            <div className="footer-logo-mark">AG</div>
            <span className="footer-logo-txt">AccuGen.ai</span>
          </Link>
          <p>Enterprise-grade AI quality and security evaluation. OWASP LLM Top 10 compliant testing for the AI-powered enterprise.</p>
        </div>

        <div className="footer-col">
          <h5>Platform</h5>
          <ul>
            <li><a href="/#capabilities">Features</a></li>
            <li><a href="/#security">Security</a></li>
            <li><a href="/#workflow">How It Works</a></li>
            <li><a href="/#services">Services</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h5>Company</h5>
          <ul>
            <li><a href="/#about">About Us</a></li>
            <li><Link to="/contact">Contact</Link></li>
            <li><a href="#blog">Blog</a></li>
            <li><a href="#careers">Careers</a></li>
          </ul>
        </div>

        <div className="footer-col">
          <h5>Legal</h5>
          <ul>
            <li><a href="#privacy">Privacy Policy</a></li>
            <li><a href="#terms">Terms &amp; Conditions</a></li>
            <li><a href="#faq">FAQ</a></li>
            <li><a href="#help">Help Center</a></li>
          </ul>
        </div>
      </div>

      <div className="footer-bottom">
        <p>© 2026 ProAutomate AI Integrations · Epro Health Care Systems. All rights reserved.</p>
        {/* <div className="footer-socials">
          <div className="footer-social">in</div>
          <div className="footer-social">tw</div>
          <div className="footer-social">gh</div>
        </div> */}
      </div>
    </footer>
  );
}
